import { render, staticRenderFns } from "./HomologsSection.vue?vue&type=template&id=77db627c&scoped=true"
import script from "./HomologsSection.vue?vue&type=script&lang=js"
export * from "./HomologsSection.vue?vue&type=script&lang=js"
import style0 from "./HomologsSection.vue?vue&type=style&index=0&id=77db627c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77db627c",
  null
  
)

export default component.exports